export default {"src":"/_next/static/media/filter-all.592ad218.svg","height":14,"width":21};